import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav className={`nav${isMenuOpen ? ' open' : ''}`}>
      <div className="nav-top">
        <Link className="nav-logo" to="/">
          <span className="logo-mark" aria-hidden="true">
            <img src="/logo.svg" alt="" />
          </span>
          CompressImages
        </Link>
        <button
          className="nav-menu-btn"
          type="button"
          aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={isMenuOpen}
          aria-controls="primary-navigation"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          {isMenuOpen ? <X /> : <Menu />}
        </button>
      </div>
      <div className="nav-links" id="primary-navigation">
        <NavLink className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`} to="/tools">Tools</NavLink>
        <NavLink className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`} to="/blog">Blog</NavLink>
        <NavLink className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`} to="/about">About</NavLink>
        <NavLink className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`} to="/contact">Contact</NavLink>
        <Link className="nav-cta" to="/tool">Compress Image</Link>
      </div>
    </nav>
  );
};

export default Navbar;
